import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import {
  ArrivingFailed,
  ArrivingLayout,
  ArrivingPending,
} from "@/client/components/arriving-layout";
import { pageTitle } from "@/client/lib/page-title";
import { PENDING_MS } from "@/client/lib/pending";
import { ProfileStep } from "@/features/onboarding/components/profile-step";
import {
  onboardingQuery,
  shownPosition,
} from "@/features/onboarding/onboarding-query";
import { useOnboardingStep } from "@/features/onboarding/use-onboarding-step";

export const Route = createFileRoute("/_authenticated/onboarding/profile")({
  pendingMs: PENDING_MS,
  pendingComponent: ArrivingPending,
  errorComponent: ArrivingFailed,
  head: async () => {
    const { onboardingCopy } = await import("@/features/onboarding/copy");
    return { meta: [{ title: pageTitle(onboardingCopy.profile.title) }] };
  },
  component: OnboardingProfile,
});

function OnboardingProfile() {
  // Read by the parent guard, so this does not suspend.
  const { data } = useSuspenseQuery(onboardingQuery);
  const flow = useOnboardingStep(data.personId);
  const { position, total } = shownPosition(data);

  return (
    <ArrivingLayout>
      <ProfileStep
        position={position}
        total={total}
        defaultName={flow.state.attempted ?? data.name}
        act={flow.act}
        busy={flow.busy}
        problem={flow.state.problem}
        nameRefused={flow.state.nameRefused}
      />
    </ArrivingLayout>
  );
}
